export default "__VITE_ASSET__BFnsxcYh__"